import { render, staticRenderFns } from "./ViewEntitiesDialog.vue?vue&type=template&id=5cf5638d&scoped=true&"
import script from "./ViewEntitiesDialog.vue?vue&type=script&lang=js&"
export * from "./ViewEntitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5638d",
  null
  
)

export default component.exports